import { Box, Button, Popover, TextField } from "@mui/material";
import React, { useState } from "react";
import { DayPicker, type DateRange } from "react-day-picker";
import FlexBox from "../../../layouts/flexbox";
import dayjs from "dayjs";
import "react-day-picker/style.css";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { CustomSelectDropdown } from "./CustomDropdown";

export interface DateRangePickerProps {
  value: DateRange | undefined;
  onSelect: (value: DateRange | undefined) => void;
  placeholder?: string;
}

export default function DateRangePicker({
  value,
  onSelect,
  placeholder = "",
}: DateRangePickerProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleDateClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDateClose = () => {
    setAnchorEl(null);
  };

  const handleDateSelect = (selectedDate: DateRange | undefined) => {
    onSelect(selectedDate);
  };

  return (
    <React.Fragment>
      <TextField
        value={
          value
            ? `${dayjs(value?.from).format("MM/DD/YYYY")} - ${dayjs(
                value?.to
              ).format("MM/DD/YYYY")}`
            : ""
        }
        onClick={handleDateClick}
        placeholder={placeholder}
        size="small"
        fullWidth
        sx={{ bgcolor: "white" }}
        InputProps={{
          readOnly: true,
          endAdornment: <InsertInvitationIcon />,
        }}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleDateClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box p={2}>
          <DayPicker
            mode="range"
            components={{ Dropdown: CustomSelectDropdown }}
            numberOfMonths={1}
            captionLayout="dropdown"
            selected={value}
            onSelect={handleDateSelect}
          />
          <FlexBox justifyContent={"space-between"} mt={1}>
            <Button
              color="secondary"
              fullWidth={false}
              onClick={() => handleDateSelect(undefined)}
            >
              Clear
            </Button>

            <Button onClick={handleDateClose} fullWidth={false}>
              Ok
            </Button>
          </FlexBox>
        </Box>
      </Popover>
    </React.Fragment>
  );
}
